import { BehaviorSubject, Subject } from 'rxjs';

export class CountdownManager {
  public readonly isHiddenAndSuspended = new BehaviorSubject<boolean>(false);
  public readonly setCountdownSubject = new Subject<number>();
  public readonly timeoutSubject = new Subject<boolean>();
  public readonly pauseSubject = new BehaviorSubject<boolean>(false);
  public readonly manualChangeSubject = new Subject<'next' | 'prev'>();
  public remainingSecondsSubject = new BehaviorSubject<number>(this.initialCountdown);

  constructor(public initialCountdown: number) {
    this.timeoutSubject.subscribe(() => {
      this.setCountdownSubject.next(this.initialCountdown);
    });

    this.setCountdownSubject.subscribe((newCountdown: number) => {
      this.initialCountdown = newCountdown;
      this.remainingSecondsSubject.next(newCountdown);
    });
  }
}
